export default __webpack_public_path__ + "static/media/Platin.2260f4a7.png";